module.exports = __webpack_public_path__ + "media/images/icon_user2-5227828139ee6c701216136989ecc33e.png";